import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
const comparisons = [{
  bad: 'Notti intere a cercare testi, creare schede e strutturare UDA da zero.',
  good: 'UDA, schede e lezioni pronti sul tuo tablet in 2 clic.'
}, {
  bad: 'Stress prima di spiegare Dante o Leopardi a classi distratte.',
  good: 'Sicurezza totale con materiali visivi che semplificano i classici più complessi.'
}, {
  bad: 'Spiegazioni teoriche che gli adolescenti trovano "impossibili" e noiose.',
  good: 'Supporti visivi moderni con mappe, schemi e laboratori di scrittura coinvolgenti.'
}, {
  bad: "Frustrazione per la burocrazia e l'allineamento al programma MIM.",
  good: "Checklist MIM e griglie di valutazione già integrate e pronte all'uso."
}, {
  bad: 'Weekend sacrificati a correggere temi e preparare verifiche.',
  good: 'Verifiche pronte con rubriche: correggi nella metà del tempo.'
}, {
  bad: 'Difficoltà a coinvolgere studenti DSA e BES con lo stesso materiale.',
  good: 'Schede differenziate Base / Intermedio / Avanzato già pronte e conformi alla Legge 170.'
}];
export function ComparisonTable() {
  return <section className="py-10 sm:py-12 px-4" data-id="element-56">
      <div className="max-w-5xl mx-auto" data-id="element-57">
        <div className="grid grid-cols-1 gap-4" data-id="element-58">
          {/* SENZA Column */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-[#1a0f0a] border border-red-900/50 rounded-2xl p-6 sm:p-8" data-id="element-59">
            <h3 className="text-2xl font-black text-red-500 mb-6 text-center uppercase tracking-wide" data-id="element-60">
              SENZA Lettere Pronte
            </h3>
            <div className="space-y-4" data-id="element-61">
              {comparisons.map((item, i) => <div key={i} className="flex gap-3 items-start" data-id="element-62">
                  <div className="mt-1 bg-red-500/20 p-1 rounded-full shrink-0" data-id="element-63">
                    <XIcon className="w-5 h-5 text-red-500" data-id="element-64" />
                  </div>
                  <p className="text-gray-300 font-medium" data-id="element-65">{item.bad}</p>
                </div>)}
            </div>
          </motion.div>

          {/* CON Column */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-b from-[#1a140a] to-[#0f0a05] border border-brand-orange/50 rounded-2xl p-6 sm:p-8 shadow-[0_0_30px_rgba(249,115,22,0.15)] relative overflow-hidden" data-id="element-66">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brand-orange to-brand-gold" data-id="element-67" />
            <h3 className="text-2xl font-black text-brand-gold mb-6 text-center uppercase tracking-wide" data-id="element-68">
              CON Lettere Pronte
            </h3>
            <div className="space-y-4" data-id="element-69">
              {comparisons.map((item, i) => <div key={i} className="flex gap-3 items-start" data-id="element-70">
                  <div className="mt-1 bg-green-500/20 p-1 rounded-full shrink-0" data-id="element-71">
                    <CheckIcon className="w-5 h-5 text-green-500" data-id="element-72" />
                  </div>
                  <p className="text-brand-cream font-bold" data-id="element-73">{item.good}</p>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}